import axios from 'axios';
import type { ApiResponse } from '@shared/types';
import { supabase } from './supabase';

const API_BASE = '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 300000, // 5 minute timeout for Claude API calls
});

// Add auth token to requests
api.interceptors.request.use(async (config) => {
  const { data: { session } } = await supabase.auth.getSession();
  if (session?.access_token) {
    config.headers.Authorization = `Bearer ${session.access_token}`;
  }
  return config;
});

// Handle API responses
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message = error.response?.data?.error?.message || error.message;
    throw new Error(message);
  }
);

export { api };

// Type-safe API wrapper
export async function apiRequest<T>(
  method: 'get' | 'post' | 'put' | 'patch' | 'delete',
  url: string,
  data?: any
): Promise<T> {
  const response: any = await api.request<ApiResponse<T>>({
    method,
    url,
    data,
  });

  if ('success' in response && !response.success) {
    throw new Error((response as any).error.message);
  }

  return response.data;
}
